import React from "react";
import PropTypes from "prop-types";
import { BreadCrumb } from "primereact/breadcrumb";
import { useIntl } from "react-intl";

const CustomBreadCrumbs = ({
  labels,
  navigate,
  editLabel,
  menuCustomised = false,
}) => {
  const intl = useIntl();
  const allowedLabels = labels?.filter((label) => label.label);
  const items = allowedLabels?.map((label, index) => {
    let title = label.label;
    const isCustomised = label.isParent && menuCustomised;
    return {
      template:
        allowedLabels.length - 1 !== index ? (
          <span className="cursor-pointer" onClick={(e) => navigate(label.to)}>
            {isCustomised ? title : intl.formatMessage({ id: title })}
          </span>
        ) : (
          <span>
            {(label.label.includes("edit") &&
              (editLabel || intl.formatMessage({ id: "..." }))) ||
              intl.formatMessage({ id: title })}
          </span>
        ),
    };
  });

  return <BreadCrumb model={items} home={{ icon: "pi pi-home" }} />;
};

CustomBreadCrumbs.propTypes = {
  labels: PropTypes.array.isRequired,
  navigate: PropTypes.func.isRequired,
  editLabel: PropTypes.string,
};

export default CustomBreadCrumbs;
